var React = require('react');
import { Link, browserHistory } from 'react-router';
import {Treemap} from 'react-vis';

var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
// import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import '../../css/components/StudentAnalytics/ViewStudentConceptMap.css';

import ChartLabel from './chart-label';

// import {
//   Highlight,
//   XYPlot
// } from 'react-vis';

// import { Pager } from 'react-bootstrap';

// import StudentsTable from './StudentsTable';
var StudentRes = require('../../resources/student');
var AnalyticsRes = require('../../resources/analytics');

const MATH_ID = 'a234e6f6-a3ee-4bfe-9143-5c52f89ac84c';
const SCIENCE_ID = '84c52703-3e79-4f8d-8376-d854093843c1';

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;

const STYLES = {
  SVG: {
    stroke: '#ddd',
    strokeWidth: '0.25',
    strokeOpacity: 0.5,
    textAlign:'center',
    fontSize:10,
    paddingOuter:32,
    margin:10
    // paddingInner:16
  },
  DOM: {
    // border: 'thin solid #ddd',
    stroke: '#ddd',
    strokeWidth: '0.25',
    strokeOpacity: 0.5,
    fontSize:10,
    // alignItems: 'center',
    // justifyContent: 'center',
    // paddingOuter:32,
    // margin:10,
    borderRadius:"100%",
    // display:'flex',
    position:'absolute',
  }
}

var ConceptMap = React.createClass({
// class ConceptMap extends React.Component { 

  // constructor(props) {
  //   super(props);
  // }

  componentWillReceiveProps: function(nextProps) {
    this.setState({
        // treeMapData:nextProps.treeMapData
        treeMapData: nextProps.treeMapData || this.state.treeMapData,
        originalData: nextProps.treeMapData || this.state.treeMapData,
        useCirclePacking: "circlePack",
        lastDrawLocation: null
    });
  },
  // getDefaultProps:function() {
  //   var _this = this;
  //       // console.log("TREEMAPDATA IS ",this.props.treeMapData);

  //   return {
  //       hoveredNode: false,
  //       treeMapData: this.props.treeMapData,
  //       useCirclePacking: false
  //     // conceptsMap: null,
  //   };
  // },
  
  getInitialState:function() {

    var _this = this;
    console.log("TREE MAP DATA IS ",this.props.treeMapData);
    return {
        hoveredNode: false,
        treeMapData: this.props.treeMapData,
        originalData: this.props.treeMapData,
        useCirclePacking: "circlePack",
        lastDrawLocation: null,
        previousLeafNode: null
      // conceptsMap: null,
    };
  },

  componentDidMount:function() {

    var _this = this;
    _this.setState({
      treeMapData: _this.state.originalData
    });
  },

  getHoveredNode: function(leafNode, domEvent) {

    var _this = this;
    alert("test");
    // console.log("CALLED ZOOM IN OUT! X IS ",leafNode );
  },

  zoomInOut:function(leafNode, domEvent) {

    var _this = this;
    // alert("CLICKED ON " + _this.state.hoveredNode.data.conceptName);//leafNode.data.conceptName);

    var foundClickedNode = null;
    
    
    console.log("CALLED ZOOM IN OUT! CLICKED ON IS ",leafNode );

    var updateMap = true;

    var ifDisplayDeepestTitles = true;

    // if (leafNode.data.level < 3) { //only if clicking on the 
    var previousLeafNode = _this.state.previousLeafNode;

    if (leafNode.data.level > 0) { //if didn't clicked on the highest level node (no point in changing the map if clicked on highest level node (i.e level 0))

      //TODO: checked if clicked on current same level. and if so, go back up 1 level
      var ifDisplayTitles = true; //to determine if need to display the titles for the various nodes or not (if going back to top level, no need)


      if (leafNode.data.level === 3) { //if no more children, get the parent for this
       
        foundClickedNode = _this.getParentConceptFor(leafNode.data._id);

      } else { //if still have children (i.e not deepest level yet), check if clicked on same node

        if (previousLeafNode!=null) {

          console.log("PREVIOUS NODE IS ",previousLeafNode);
          if (leafNode.data.title === previousLeafNode.title) { //if clicked on the same node, get the parent for this node and move back up 1 level

            foundClickedNode = _this.getParentConceptFor(leafNode.data._id);

            if (foundClickedNode.level === 0) { ifDisplayDeepestTitles = false; } //if going back to the highest level, don't display the titles for the deepest level
          
          } else { //if didn't click on same node, move in deeper within the clicked node

            foundClickedNode = _this.getConceptAndChildren(leafNode.data._id);
          }

        } else { //if first click

          foundClickedNode = _this.getConceptAndChildren(leafNode.data._id);
        }

        previousLeafNode = foundClickedNode;
        
      }

    } else { //if clicked on highest level

      previousLeafNode = leafNode;
    }

    _this.setState({ previousLeafNode: previousLeafNode });


      // if (previousLeafNode!=null) {

      //   console.log("PREVIOUS LEAF NODE IS ",previousLeafNode.data.title);
      //   console.log("PREVIOUSLY CLICKED ON ", previousLeafNode.data.title);

      //   if (previousLeafNode.data.title === leafNode.data.title) { //if clicked on the same node

      //     console.log("CLICKED ON THE SAME NODE!!!");

      //     if (leafNode.data.level === 0) { //but if this same node is already the top level (or if top level)

      //       ifDisplayTitles = false;
      //       updateMap = false;
      //       previousLeafNode = leafNode;
      //       // if (leafNode.data.level === 0) {  }
      //       console.log("DO NOTHING!");

      //     } else {

      //       //TODO: search for the parent node for this leaf node in the original data and set it to the state
      //       foundClickedNode = _this.getParentConceptFor(leafNode.data._id);
      //       previousLeafNode = foundClickedNode;

      //       // if (foundClickedNode.data.level < 3) { ifDisplayTitles = }
      //       ifDisplayTitles = false;
      //       // if (leafNode.parent.data._id) { //if haven't reached top level yet (e.g Maths)
            
      //       //   foundClickedNode = _this.getConceptAndChildren(leafNode.parent.data._id);
      //       //   previousLeafNode = foundClickedNode;

      //       // } else {

      //       //   foundClickedNode = _this.state.originalData;
      //       //   ifDisplayTitles = false;
      //       // }
      //     }
 
      //   } else { //if didn't clicked on the same node as the previous node

      //     // foundClickedNode = _this.getParentConceptFor(leafNode.data._id);
      //     previousLeafNode = foundClickedNode;
      //   }

      // } 
      
      // else { //if haven't previously clicked on any nodes yet

      //   if (leafNode.data.level === 0) { 

      //     updateMap = false;
      //     ifDisplayTitles = false;
      //     previousLeafNode = leafNode;
        
      //   } else {
      //     previousLeafNode = foundClickedNode; 
      //   }
      // }

      _this.setState({ previousLeafNode: previousLeafNode });




      //display the titles for those that are above level 1
      if (ifDisplayTitles) {
          
        var foundLength = foundClickedNode.children.length;
        for (var i = 0; i < foundLength; i++) {
          
          var thisNode = foundClickedNode.children[i];
          
          // console.log("CONCEPT IS ",thisNode.conceptName);
          // console.log("LEVEL IS ", thisNode.level);
          if (thisNode.level > 1) { 

            thisNode.title = thisNode.conceptName;
            // if (ifDisplayTitles) { thisNode.title = thisNode.conceptName; }
            // else { thisNode.title = ""; }
          }

          var thisNodeChild = thisNode.children;
          if (thisNodeChild!=null) {

            var thisNodeChildLength = thisNodeChild.length;

            for (var x = 0; x < thisNodeChildLength; x++) {

              var thisInnerChild = thisNodeChild[x];
              
              if (thisInnerChild.level > 1) { 
                
                thisInnerChild.title = thisInnerChild.conceptName;
                // if (ifDisplayTitles) {  thisInnerChild.title = thisInnerChild.conceptName; }
                // else { thisInnerChild.title = ""; }
              }
            
              var thisInnestChild = thisInnerChild.children;

              if (thisInnestChild!=null) {

                var thisInnestChildLength = thisInnestChild.length;

                for (var z = 0; z < thisInnestChildLength; z++) {

                  var smallestChild = thisInnestChild[z];
                  
                  if (smallestChild.level > 1) { 
                    
                    if (ifDisplayDeepestTitles) {
                      smallestChild.title = smallestChild.conceptName;
                    } else {
                      smallestChild.title = "";
                    }
                    // if (ifDisplayTitles) { smallestChild.title = smallestChild.conceptName; }
                    // else { smallestChild.title = ""; }
                  }
                }
              }
            }
          }
        }
      }

      // console.log("CHANGED ",foundClickedNode );

    if (updateMap) {

      _this.setState({
        treeMapData: foundClickedNode
      });
    }
    // }
  },

  changeDisplayTitlesForMap:function() {

  },

  getParentConceptFor:function(conceptID) { //to search for a concept's parent concept and the parent's node in the original data

    var _this = this;
    var originalDataParent = _this.state.originalData;
    var originalData = originalDataParent.children;
    var originalLength = originalData.length;

    var foundNode = null;
    for (var x = 0; x < originalLength; x++) {

      var thisNode = originalData[x];

      if (thisNode._id === conceptID) { return originalDataParent; }

      var thisChildren = thisNode.children;
      var length = thisChildren.length;
      for (var i = 0; i < length; i++) {
        
        var thisChild = thisChildren[i];
        if (thisChild._id === conceptID) { return thisNode; }

        var innerChildren = thisChild.children;
        var innerLength = innerChildren.length;
        for (var m = 0; m < innerLength; m++) {

          var thisInnerChild = innerChildren[m];
          
          if (thisInnerChild._id === conceptID) { return thisChild; }
        }
      }
    }
  },

  getConceptAndChildren:function(_clickedID) { //to search for and find the clicked concept node and it's children (so that we can know which to display into the map)

    var _this = this;
    var originalData = _this.state.originalData;
    originalData = originalData.children;
    var originalLength = originalData.length;

    var foundNode = null;
    for (var x = 0; x < originalLength; x++) {

      var thisNode = originalData[x];
      
      if (thisNode._id === _clickedID) { return thisNode; }

      var thisChildren = thisNode.children;
      var length = thisChildren.length;
      for (var i = 0; i < length; i++) {
        
        var thisChild = thisChildren[i];
        
        if (thisChild._id === _clickedID) { return thisChild; }

        var innerChildren = thisChild.children;
        var innerLength = innerChildren.length;
        for (var m = 0; m < innerLength; m++) {

          var thisInnerChild = innerChildren[m];
          
          if (thisInnerChild._id === _clickedID) { return thisInnerChild; }
        }
      }
    }
  },

  render:function() {
    var _this = this;

    const {hoveredNode, useCirclePacking, lastDrawLocation} = _this.state;
    const treeProps = {
      animation: {
        damping: 9,
        stiffness: 300
      },
      data: _this.state.treeMapData,
      // onLeafMouseOver: x => _this.setState({hoveredNode: x}),
      // onLeafMouseOut: () => _this.setState({hoveredNode: false}),
    //   onLeafClick: () => this.setState({treeMapData: _getRandomData()}),
      height: 300,
      mode: _this.state.useCirclePacking ? 'circlePack' : 'circlePack',
      getLabel: x => x.name,
      width: 350
    };

    return (
        <div className="dynamic-treemap-example">
          
            <Treemap 
              animation={{damping:9,stiffness:300}}
              onLeafMouseOver={ (x) => _this.setState({hoveredNode: x})}
              onLeafMouseOut={ () => _this.setState({hoveredNode: false})}
              onLeafClick={_this.zoomInOut.bind(_this)}
              data={_this.state.treeMapData}
              height={888}
              width={888}
              colorType={'literal'}
              //padding={2}
              //getLabel={x => x.name}
              style={STYLES['DOM']}
              mode={_this.state.useCirclePacking}
              renderMode={'DOM'}
             />
        </div>
    );
  }

});

module.exports = ConceptMap;



/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/ConceptMap.js
 **/